/**
 * 板块编辑 store
 */
import blkEditApi from '../../api/blk.edit.api'

const state = {
	showLiveBlkEdit: false,
	editType: 'addTo', // addTo: 追加， amend 修改
	nodeParams: {
		divNodeId: '',
		dlNodeId: ''
	}
}
const mutations = {
	setLiveEditState(state, data) {
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				state[key] = data[key]
			}
		}
	}
}
const getters = {}
const actions = {

}
const liveEdit = {
	state,
	mutations,
	getters,
	actions,
	namespaced: true
}

export default liveEdit
